// extracted by mini-css-extract-plugin
var _1 = "DocFlowProfileHeaderActionsBase-modulearchive__pVzVW";
export { _1 as "archive" }
